import React, { useEffect } from "react"

const ContactForm = props => {
  const { hubSpotForm } = props
  useEffect(() => {
    const script = document.createElement("script")
    script.src = "https://js.hsforms.net/forms/v2.js"
    document.body.appendChild(script)

    window.addEventListener("message", function (event) {
      if (
        event.data.type === "hsFormCallback" &&
        event.data.eventName === "onFormSubmitted" &&
        event.data.id === hubSpotForm.id
      ) {
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({
          event: "hubspot-form-success",
          "hs-form-guid": hubSpotForm.id,
        })
      }
    })

    script.addEventListener("load", () => {
      // @TS-ignore
      if (window.hbspt) {
        // @TS-ignore
        window.hbspt.forms.create({
          portalId: hubSpotForm.portalId,
          formId: hubSpotForm.id,
          target: "#hubSpotForm",
        })
      }
    })
  }, [hubSpotForm])

  return (
    <div>
      <h2>Get in touch.</h2>
      <hr />
      <p>Send us a message and we’ll get right back to you.</p>
      <div id="hubSpotForm" />
    </div>
  )
}

export default ContactForm
